import { Reveal, Chapter } from "./Reveal";

const STEPS = [
  {
    num: "01",
    title: "Set up your page",
    copy: "Services · Now · Policies",
  },
  {
    num: "02",
    title: "Share your link",
    copy: "Instagram · TikTok · Facebook · WhatsApp · QR",
  },
  {
    num: "03",
    title: "Clients take the next step",
    copy: "They choose what they need and continue the conversation in WhatsApp.",
  },
];

const HowItWorks = () => (
  <section id="how-it-works" className="scroll-mt-20 py-14 sm:py-20">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Chapter num="03" label="How it works" />
      <div className="mt-10 max-w-2xl">
        <Reveal delay={0.05}>
          <h2 className="font-serif text-3xl font-medium leading-[1.12] tracking-tight text-guinep-ink sm:text-5xl">
            From your social page to a clearer enquiry.
          </h2>
        </Reveal>
      </div>

      <div className="mt-10 grid gap-8 md:grid-cols-3 md:gap-6">
        {STEPS.map((s, i) => (
          <Reveal key={s.num} delay={0.08 * i} className="h-full">
            <div
              data-testid="how-it-works-step"
              className="group relative h-full border-t-2 border-guinep-line pt-6 transition-colors duration-500 hover:border-guinep-mid"
            >
              <span className="font-serif text-6xl font-medium text-guinep-line transition-colors duration-500 group-hover:text-guinep-mid/60 sm:text-7xl">
                {s.num}
              </span>
              <h3 className="mt-4 text-xl font-semibold text-guinep-ink">{s.title}</h3>
              <p className="mt-2 max-w-xs text-sm leading-relaxed text-guinep-mute sm:text-base">
                {s.copy}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
